import React, { useState } from "react";

import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material";
import { Menu, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import Button from "../Button";
import useStyles from "./styles";
import { colors } from "@zapalacorp/tokens";

type Props = {
  isDateRange?: boolean;
  setIsDateRange?: (isDateRange: boolean) => void;
  error?: boolean;
  disabled?: boolean;
  block?: boolean;
};

const FilterMenu = (props: Props) => {
  const { isDateRange, setIsDateRange, error, disabled, block = true } = props;

  const classes = useStyles({
    bordercolor: error ? "#D92D20" : colors.brandBlue500,
    disabled,
    block,
  });

  const { t: translate } = useTranslation();

  const [dateMenuAnchor, setDateMenuAnchor] = useState<null | HTMLElement>(null);

  const showOptions = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setDateMenuAnchor(event.currentTarget);
  };

  return (
    <div className={classes.borderDiv}>
      <Typography
        sx={{
          color: "#667085",
          fontFamily: "Manrope",
          fontWeight: 500,
          fontSize: "1rem",
          lineHeight: "24px",
        }}
      >
        {translate("filter")}
      </Typography>
      <Button
        disabled={disabled}
        className={classes.button}
        onClick={showOptions}
        endIcon={<KeyboardArrowDownIcon htmlColor="#667085" />}
        size="small"
      >
        {isDateRange ? translate("dateRange") : translate("date")}
      </Button>
      <Menu
        anchorEl={dateMenuAnchor}
        open={Boolean(dateMenuAnchor)}
        onClose={() => {
          setDateMenuAnchor(null);
        }}
      >
        <MenuItem
          onClick={() => {
            setDateMenuAnchor(null);
            if (setIsDateRange) setIsDateRange(false);
          }}
        >
          {translate("date")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setDateMenuAnchor(null);
            if (setIsDateRange) setIsDateRange(true);
          }}
        >
          {translate("dateRange")}
        </MenuItem>
      </Menu>
    </div>
  );
};

export default FilterMenu;
